import { OptionCard, StepBody, StepHeader, StepNav } from "./AiboxWizardParts";

const USAGE_OPTIONS = [
    { key: "Control", title: "Control AiBox", subtitle: "Control the status of the hub, channels, rules or relays" },
    { key: "Live view", title: "Live camera viewing", subtitle: "Stream the camera feed" },
];

const AiboxStepUsage = ({ selectedOptions, setSelectedOptions, onNext }) => {
    const toggle = (key) => {
        setSelectedOptions(prev => prev.includes(key) ? prev.filter(x => x !== key) : [...prev, key]);
    };

    return (
        <>
            <StepHeader title="How would you like to use the Ganz AiBox?" subtitle="Choose one or both" />
            <StepBody>
                {USAGE_OPTIONS.map(opt => (
                    <OptionCard
                        key={opt.key}
                        title={opt.title}
                        subtitle={opt.subtitle}
                        selected={selectedOptions.includes(opt.key)}
                        onClick={() => toggle(opt.key)}
                    />
                ))}
            </StepBody>
            <StepNav onNext={onNext} nextDisabled={selectedOptions.length === 0} />
        </>
    );
};

export default AiboxStepUsage;
